import { render, staticRenderFns } from "./Manage_averageEdit.vue?vue&type=template&id=7526493c&"
import script from "./Manage_averageEdit.vue?vue&type=script&lang=js&"
export * from "./Manage_averageEdit.vue?vue&type=script&lang=js&"
import style0 from "./Manage_averageEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports